import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslocoDirective, TranslocoPipe} from '@jsverse/transloco';
import {TooltipModule} from 'primeng/tooltip';
import {UseCaseItem} from '../demonstration.model';
import {ModelFieldSelectInclusionComponent} from '../../../../../../../shared/components/inputs/model-field/model-field-select-inclusion/model-field-select-inclusion.component';

@Component({
  selector: 'app-demonstration-use-case-item',
  imports: [
    FormsModule,
    TranslocoDirective,
    ModelFieldSelectInclusionComponent,
    TooltipModule,
    TranslocoPipe,
  ],
  templateUrl: './demonstration-use-case-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DemonstrationUseCaseItemComponent {
  useCase = input.required<UseCaseItem>();
  included = input.required<boolean | null>();
  disabled = input.required<boolean>();
  lockedTooltip = input<string | undefined>('');

  includedChange = output<boolean | null>();

  protected formatDuration(minutes: number): string {
    return `${minutes} min`;
  }

  protected onInclusionChange(value: boolean | null) {
    this.includedChange.emit(value);
  }
}
